import { Log } from "../../utils/logging";
import { addChoiceItemFailed } from "../actions";
import { ThunkActionType } from "../actions/types";
import { makeAxios } from "./validation";

export function addChoiceItem(
    questionName: string,
    tableName: string,
    params: Record<string, string>,
): ThunkActionType<Promise<number>> {
    return async (dispatch, getState) => {
        try {
            Log.d("lookuptable", "Creating a new choice item");
            const result = await dispatch(makeAxios()).post("s/addLookupTableName?", {
                formdata: JSON.stringify(params),
                questionName,
                tableName,
            });

            if (result.status !== 200) throw new Error(`Unexpected status ${result.status}`);
            if (result.data.success !== true)
                throw new Error(`Unexpected response ${result.data.success}`);
            if (!result.data.data || !result.data.data.id)
                throw new Error(`Unexpected error, lookup choice item is not created`);
            return result.data.data.id;
        } catch (err) {
            dispatch(addChoiceItemFailed(questionName, tableName, params, err));
            return null;
        }
    };
}
